import { StylesClasses, createStyles } from '@utils/styles'

const styles = createStyles({
  mapWrapper: {
    width: '100%',
    height: {
      xs: '224px',
      md: '458px',
    },
    marginTop: '32px',
    borderRadius: '16px',
    overflow: 'hidden',
  },
})

export type StyleClassNames = StylesClasses<typeof styles>

export default styles
